import type { Version3Models } from 'jira.js';

import { apiRequest } from '../../../api-client';

export type IssueType = Version3Models.IssueTypeDetails;

export interface ProjectsAndIssueTypes extends Version3Models.Project {
  canCreateIssue: boolean;
  isRecent?: boolean;
}

const getProjectsAndIssueTypes = async ({
  enterpriseId,
  connectionId,
  token
}: {
  enterpriseId: string;
  connectionId: string;
  token?: string;
}) => {
  const projectsAndIssueTypes = await apiRequest<ProjectsAndIssueTypes[]>({
    endpoint: `/api/integrations/enterprises/${enterpriseId}/connections/${connectionId}/projects`,
    token
  });

  const projectsWithEmptyIssueTypes = projectsAndIssueTypes
    .filter(project => !project?.issueTypes?.length)
    .map(({ name }) => name);

  if (projectsWithEmptyIssueTypes.length) {
    // eslint-disable-next-line no-console
    console.warn(
      'Can not get issue types for the following projects: ',
      projectsWithEmptyIssueTypes.join(', ')
    );
  }

  const projectsWithoutCreateIssues = projectsAndIssueTypes
    .filter(project => !project.canCreateIssue)
    .map(({ name }) => name);

  if (projectsWithoutCreateIssues.length) {
    // eslint-disable-next-line no-console
    console.warn(
      'User who installed the connection does not have permission to create issues for the following projects: ',
      projectsWithoutCreateIssues.join(', ')
    );
  }

  return (
    projectsAndIssueTypes
      // Filter out issueTypes that have a property 'subtask' set to true
      .map(project => ({
        ...project,
        issueTypes: project.issueTypes?.filter(issueType => !issueType.subtask)
      }))
      // Filter out projects that don't have any issueTypes left after the previous filter or that don't have the canCreateIssue property set to true
      .filter(
        project =>
          project.issueTypes &&
          project.issueTypes.length > 0 &&
          project.canCreateIssue
      )
  );
};

export default getProjectsAndIssueTypes;
